<template>
  <div class="container-div">

    <h1> Visualisation de l'arborescence  des projets </h1>

	<div id="switchStatusClients">
      <input type="radio" class="radio-button" id="active" value="0" v-model="showAllProject"/>
      <label for="active" class="radio-button" style="margin-right: 15px"> Projets Activés </label>
      <input type="radio" class="radio-button" id="all" value="1" v-model="showAllProject"/>
      <label for="all" class="radio-button"> Tous les projets </label>
    </div>
    <div class="arbo">
		<div class="parent-project">
			<div class="parent-path">
				<div class="before-parent-name"> 
					<p v-if="projectPath != '/'" class="mo-margin return" v-on:click="backParent()">&lsaquo;</p>
					<p class="mo-margin label-parent-name"> Projet parent : </p>
				</div>
				<div class="parent-name">
					<p class="mo-margin"> {{this.projectPath}}</p>
				</div>
			</div>

			<div v-if="projectPath != '/'" class="return-racine btnDisable btn btn-outline-success" v-on:click="backRoot()">
				<span>Retour à la racine</span>
			</div>
		</div>

		<hr>

		<div class="project-list">
			<p :class="['project-name mo-margin', 
                    { disable: !project.status },
					{ selected: selectedProject.id == project.id},
                  ]" v-for="project in this.projects" :key="project.id" 
				v-on:click="selectProject(project)">
				{{project.name}}
			</p>
		</div>

    </div>

	<div class="project-forms">
		<div class="infos-project-selected">

			<p class="strong-p">Modification du projet {{this.selectedProject.name}}</p>

			<div class="errors">
				<p v-for="err in errorsUpdate" :key="err">{{err}}</p>
			</div>

			<div class="change-form">
				<table>
					<tr>
						<td class="label-form">Nom* : </td>
						<td class="input-form">
							<input
								id="projectName"
								placeholder="Nom "
								@change="updateProjectField()"
								v-model.lazy="selectedProject.name"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Description : </td>
						<td class="input-form">
							<input
								id="projectDescription"
								placeholder="Description "
								@change="updateProjectField()"
								v-model.lazy="selectedProject.description"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Reference* : </td>
						<td class="input-form">
							<input
								id="projectReference"
								placeholder="Reference "
								@change="updateProjectField()"
								v-model.lazy="selectedProject.ref"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Responsable* : </td>
						<td class="input-form" >
							<select
								id="projectResponsable"
								name="projectResponsable"
								@change="updateProjectField()"
								v-model="selectedProject.responsable"
								placeholder="Choix du responsable projet"
							>
								<option
								v-for="user in allUsers"
								v-bind:key="user.id"
								v-bind:value="user.id"
								>
								{{ user.login }}
								</option>
							</select>
						</td>
					</tr>

					<tr v-if="selectedProject.status">
						<td class="label-form"></td>
						<td class="input-form">
							<div class="btnDisable btn btn-outline-danger" v-on:click="changeProjectStatus">
								<span>
								Désactiver
								</span>
							</div>
						</td>
					</tr>
					<tr v-else>
						<td class="label-form"></td>
						<td class="input-form">
							<div class="btnDisable btn btn-outline-success" v-on:click="changeProjectStatus">
								<span>
								Activer
								</span>
							</div>
						</td>
					</tr>
				</table>
			</div>

		</div>

		<div class="new-project">
			<p class="strong-p">Créer un projet dans : {{this.newProjectPath}}</p>

			<div class="errors">
				<p v-for="err in errors" :key="err">{{err}}</p>
			</div>

			<div class="change-form">
				<table>
					<tr>
						<td class="label-form">Nom* : </td>
						<td class="input-form">
							<input
								id="newProjectName"
								placeholder="Nom "
								v-model="newProject.name"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Description : </td>
						<td class="input-form">
							<input
								id="newProjectDescription"
								placeholder="Description "
								v-model="newProject.description"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Reference* : </td>
						<td class="input-form">
							<input
								id="newProjectReference"
								placeholder="Reference "
								v-model="newProject.ref"
							/>
						</td>
					</tr>

					<tr>
						<td class="label-form">Responsable* : </td>
						<td class="input-form" >
							<select
								id="newProjectResponsable"
								name="newProjectResponsable"
								v-model="newProject.responsable"
								placeholder="Choix du responsable projet"
							>
								<option
								v-for="user in allUsers"
								v-bind:key="user.id"
								v-bind:value="user.id"
								>
								{{ user.login }}
								</option>
							</select>
						</td>
					</tr>

					<tr>
						<td class="label-form"></td>
						<td class="input-form">
							<div class="btnDisable btn btn-outline-success" v-on:click="createNewProject">
								<span>
								Sauvegarder
								</span>
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>

  </div>
</template>

<script>
const axios = require("axios");

export default {
	name: "Projet",
	data() {
		return {
			showAllProject: 0,
			projects: [],
			parentProject: {},
			selectedProject: {},
			projectPath : "/",
			newProject : {
				name : "",
				description: null,
				ref: null,
				responsable: 0,
				parent: null,
				status: 1,
			},
			errors : [],
			errorsUpdate: [],
			newProjectPath : "/",
			allUsers : [],
		};
	},
	created: function() {

		//Recuperation de la liste des utilisateurs pour le selecteur responsable
            axios.get(this.$store.state.apiUrl + "user/users", {
                params: {
                    login: localStorage.login,
                    password: localStorage.pass
                }
            }).then(response => {
				this.allUsers = response.data;

				//Ajout de la mention pour effacer le responsable
				var void_user = {
					id : 0,
					login : "Aucun responsable",
				}
				this.allUsers.push(void_user);
			})
            .catch(e => { this.printError(e); });
		this.getProjects();
	},
	methods: {
		getProjects: function(){
			
			// Initialisation du parent à la racine ou au parent actuel si défini
			var parent_id = -1;
			if(this.parentProject.id != null) parent_id = this.parentProject.id;

			//Réccupération des projet enfant du projet parent courrant
			axios.get(this.$store.state.apiUrl + "project/getForParent/" + parent_id + "/" + this.showAllProject, {
				params: {
					login: localStorage.login,
					password: localStorage.pass
				}
			})
			.then(response => {
				this.projects = response.data;
			})
			.catch(e => {
				this.printError(e);
			});

		},
		selectProject: function(project) { //Event click sur projet dans la liste

			if(typeof project.id == "undefined") return;

			//Réccupération du projet sélectionné
			axios.get(this.$store.state.apiUrl + "project/getProjectById/" + project.id, {
				params: {
					login: localStorage.login,
					password: localStorage.pass
				}
			})
			.then(response => {
				this.selectedProject = response.data[0];

				//Réccupération du chemin du projet parent sélectionné pour le parent de nouveau projet potentiel
				axios.get(this.$store.state.apiUrl + "project/getPath/" + this.selectedProject.id, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(resNewPath => {
					this.newProjectPath = resNewPath.data;
				})
				.catch(e => {
					this.printError(e);
				});

				//Réccupération des projet enfant du projet parent sélectionné
				axios.get(this.$store.state.apiUrl + "project/getForParent/" + this.selectedProject.id + "/" + this.showAllProject, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(res => {
					if(res.data.length > 0){
						this.parentProject = response.data[0];
						this.projects = res.data;

						//Réccupération du chemin du projet parent sélectionné
						axios.get(this.$store.state.apiUrl + "project/getPath/" + this.parentProject.id, {
							params: {
								login: localStorage.login,
								password: localStorage.pass
							}
						})
						.then(resPath => {
							this.projectPath = resPath.data;
						})
						.catch(e => {
							this.printError(e);
						});
					}
				})
				.catch(e => {
					this.printError(e);
				});

			})
			.catch(e => {
				this.printError(e);
			});
		},
		backParent: function(){ //Event click bouton retour
			
			if(this.parentProject.parent == null){
				this.parentProject = {};
				this.projectPath = "/";
				this.getProjects();
			}else{

				// Réccupération du parent du projet parent courrant
				axios
				.get(this.$store.state.apiUrl + "project/getProjectById/" + this.parentProject.parent, {
					params: {
						login: localStorage.login,
						password: localStorage.pass
					}
				})
				.then(res => {
					this.parentProject = res.data[0];

					//Réccupération du chemin du projet parent courrant
					axios
					.get(this.$store.state.apiUrl + "project/getPath/" + this.parentProject.id, {
						params: {
							login: localStorage.login,
							password: localStorage.pass
						}
					})
					.then(resPath => {
						this.projectPath = resPath.data;
					})
					.catch(e => {
						this.printError(e);
					});

					this.getProjects();
				})
				.catch(e => {
					this.printError(e);
				});
			}

		},
		updateProjectField: function(){
			/* ! CHANGEMENT RECCURSIF DU RESPONSABLE ! */

			var project = this.selectedProject;

			this.errorsUpdate = [];

			// GESTION DES ERREURS DE FORMULAIRE //

			// nom
			if(project.name == "" || project.name == null){
				this.errorsUpdate.push("Le nom de projet est obligatoire");
			}

			// ref
			if(project.ref == "" || project.ref == null){
				this.errorsUpdate.push("La référence projet est obligatoire");
			}

			if(this.errorsUpdate.length != 0) return;

			if(project.responsable == null) project.responsable = 0;

			//Réccupération de la valeur des champs de modification de projet
			var data = {
				name: project.name,
				description: project.description,
				ref: project.ref,
				responsable : project.responsable,
			};

			// Requete de mise à jour du projet courrant
			axios
			.put(this.$store.state.apiUrl + "project/update/" + project.id, data, {
				params: {
					login: localStorage.login,
					password: localStorage.pass
				}
			})
			.then( () => {
				this.$toasted.show("Mise à jours du projet effectués", {
					position: 'bottom-center',
					theme: 'outline'
				}).goAway(2500);
			})
			.catch(e => {
				this.printError(e);
			});
		},
		changeProjectStatus: function(){
			var project = this.selectedProject;
			if(typeof project.id == "undefined") return;

			// requete de changement de status du projet courrant (réccursif sur les enfants)
			axios
			.put(
				this.$store.state.apiUrl + "project/toggleStatus/" + project.id,
				null,
				{
					params: {
					login: localStorage.login,
					password: localStorage.pass
					}
				}
			)
			.then(response => {
				if (response.status == 200) {
					project.status = !project.status;
					this.getProjects();
				}
			})
			.catch(e => {
			this.printError(e);
			});
		},
		createNewProject: function(){
			this.errors = [];

			if(typeof this.selectedProject.id == "undefined"){
				this.newProject.parent = null;
			}else{
				this.newProject.parent = this.selectedProject.id;
			}

			var tmpData = new FormData();
			for (var field in this.newProject) {
				tmpData.append(field, this.newProject[field]);
			}

			// Requete d'ajout du nouveau projet
			axios
			.post(this.$store.state.apiUrl + "project/new", tmpData, {
			params: {
				login: localStorage.login,
				password: localStorage.pass
			}
			})
			.then(response => {

				// Si succès : réinitialisation des données du formulaire 
				//				+ notif d'enregistrement du nouveau projet
				if (response.status == 200) {
					this.newProject  = {
						name : "",
						description: null,
						ref: null,
						parent: null,
						responsable: 0,
						status: 1,
					};
					this.errors = [];

					this.$toasted.show("Nouveau projet enregistrer", {
						position: 'bottom-center',
						theme: 'outline'
					}).goAway(2000);

					this.selectProject(this.selectedProject);
					this.getProjects();

				} else if(response.status == 202){
					this.errors = ["Erreur de connexion à la base, veuillez essayer ultérieurement"];
				}else {
					this.errors = response.data;
				}
			})
			.catch(e => {
				this.printError(e);
			});

		},
		backRoot: function(){ //Event click retour racine

			// Fonction de retour à la racine des projets
			this.projectPath = "/";
			this.newProjectPath = "/";
			this.parentProject = {};
			this.selectedProject = {};
			this.getProjects();
		},
		printError: function(e) {
			console.log(e);
			this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
				position: 'bottom-center',
				theme: 'outline'
			}).goAway(2000);
		},
	},
	watch: {
		showAllProject : function(){
			this.getProjects();
		}
	}
};
</script>

<style scoped>

	.container-div{
		width: 95%;
		margin: auto;
		margin-bottom: 10%;
		margin-bottom: 20%;
	}

	.errors p{
		margin: 0;
	}

	.arbo{
		width: 33%;
		
	}

	.infos-project-selected, .new-project{
		width: 75%;
	}

	.arbo, .infos-project-selected, .new-project{
		border: solid 1px #aaa;
		border-radius: 3px;
		padding: 1%;
		margin: 5%;
		display: inline-table;
	}

	.arbo{
		text-align: left;
	}

	.return, .parent-name, .before-parent-name{
		display: inline-table;
	}

	.return{
		width: 20px;
		border-right: solid 1px #aaa;
		font-size: 1.5em;
		height: 1.5em;
		font-weight: bold;
		cursor: pointer;
	}

	.before-parent-name{
		width: 140px;
	}

	.mo-margin{
		margin: 0;
	}

	hr{
		background-color: #aaa;
		margin: 0;
	}

	.before-parent-name {
		padding: 0.5% 0.5%;
	}

	.radio-button{
		cursor: pointer;
		margin-top: 0.5%;
	}

	.disable{
		background-color: #ff5050a3;
		border-radius: 3px;
	}

	.label-parent-name{
		display: inline-table;
		margin-left: 5%;
	}

	.selected{
		border-radius: 3px;
		border: solid 2px #8d8;
	}

	table{
		width: 100%;
	}

	.label-form{
		text-align: right;
		margin-right: 5%;
	}

	.input-form{
		text-align: left;
	}

	thead{
		text-align: center;
	}

	.strong-p{
		font-weight: bold;
	}

	.errors{
		color: #dc3545;
	}

	.return-racine{
		margin-bottom: 2%;
	}

	.parent-path{
		display: inline-block;
		width: 60%;
	}
	
	.project-forms{
		width: 45%;
		display: inline-table;
	}

	@media screen and (max-width: 700px){
		.arbo, .infos-project-selected, .new-project{
			width: 70%;
		}

		.new-project{
			right: 10%;
		}
	}

</style>
